import { useEffect, useRef, useState } from 'react';
import anime from 'animejs';
import logo from '../karuncup.svg';
import TemporaryDrawer from './drawer';

function Navbar({ dir }) {
  const logoRef = useRef(null); // Ref for the logo
  const [isScrolled, setIsScrolled] = useState(false);
  const [ruleTitle, setRuleTitle] = useState("قوانین");
  const [ruleUrl, setRuleUrl] = useState(`${dir}rules`);
  const [ruleExists, setRuleExists] = useState(false);
 
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 0 && !isScrolled) {
        setIsScrolled(true); // Mark as scrolled
      } else if (scrollY === 0 && isScrolled) {
        setIsScrolled(false); // Mark as not scrolled
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isScrolled]);

  useEffect(() => {
    if (isScrolled) {
      // Animate logo size when scrolled
      anime({
        targets: logoRef.current,
        height: '2.5rem', // Equivalent to `h-8`
        easing: 'easeOutQuad',
        duration: 300,
      });
    } else {
      // Animate logo size back to original
      anime({
        targets: logoRef.current,
        height: '4.5rem', // Equivalent to `h-10`
        easing: 'easeOutQuad',
        duration: 300,
      });
    }
  }, [isScrolled]);

  // fetch rules title & download link from backend
  useEffect(() => {
    const url = `${process.env.REACT_APP_BACKEND_URL || ''}/api/rules/`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        if (!data) return;
        // API returns an array — pick the first item if so
        const item = Array.isArray(data) ? data[0] : data;
        if (!item) return;
        
        // If a rules item exists, show internal /terms page instead of external download
        setRuleExists(true);
        setRuleUrl(`${dir}terms`);
      })
      .catch(() => {
        // ignore - keep defaults
      });
  }, [dir]);

 return (
  <nav className="fixed w-full top-0 right-0 z-50 bg-black/70" dir="rtl">
    <div className="max-w-screen-2xl flex flex-row items-center justify-between mx-auto p-4 px-2">
      
      {/* LOGO */}
      <a href={`../${dir}`} className="flex items-center space-x-3">
        <img
          ref={logoRef}
          src={logo}
          className="transition-all duration-300 pr-10"
          alt="Logo"
        />
      </a>

      {/* منوی افقی (فقط دسکتاپ) */}
      <div className="flex items-center gap-6 md:order-1">
        <a
          href={`${dir}gallery`}
          className="hidden md:block text-sm hover:text-lime-400 transition"
        >
          گالری
        </a>
        <a
          href={`${dir}about`}
          className="hidden md:block text-sm hover:text-lime-400 transition"
        >
          درباره ما
        </a>
        {ruleExists ? (
          <a href={`${dir}terms`} className="text-sm hover:text-lime-400 transition">{ruleTitle}</a>
        ) : (
          <></>
  )}

        <a
          href={`${dir}LogIn`}
          className="ml-4 text-black bg-lime-400 hover:bg-lime-500 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center"
        >
          ورود
        </a>
      </div>

      {/* منوی همبرگری (فقط موبایل) */}
      <div className="md:hidden flex items-center">
        <TemporaryDrawer />
      </div>

    </div>
  </nav>
);

}

export default Navbar;
